import React, { useState } from "react";
import { HeaderComponent, BodyComponent, SaveButton, } from '@comps/components';
import { Form, Row, Col, Input } from "antd";
import toast from "@comps/toast";
import { getErrorProps, makeRequest } from "@utils/helpers";
import { changePasswordReq } from "./requests";

const pageConfig = {
  headers: {
    title: "Profile",
    breadcrumb: [
      {
        name: "Profile",
        path: "/"
      }
    ]
  }
}

const formName = "change_password_form";

const ChangePassword = () => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [form] = Form.useForm();

  const onError = (data, res) => {
    setErrors(Array.isArray(data) ? { new_password: data } : []);
    toast.error((res && res.msg) || "Something went wrong");
  }

  const onFinish = (values) => {
    const payload = {
      current_password: values.current_password,
      new_password: values.new_password,
      new_password_confirmation: values.new_password_confirmation,
    };
    makeRequest(setLoader, changePasswordReq, payload, onUpdateSuccess, onError);
  }

  const onUpdateSuccess = () => {
    toast.success("Password changed successfully");
    form.resetFields();
  }

  return (
    <>
      <HeaderComponent headers={ pageConfig.headers }>
      </HeaderComponent>
      <BodyComponent narrow>
        <h3>Change Password</h3>
        <Form
          form={ form }
          layout="vertical"
          name={ formName }
          onFinish={ onFinish }
        >
          <div style={ { padding: 30 } }>
            <Row gutter={ 30 }>
              <Col span={ 24 }>
                <Form.Item onChange={
                  () => setErrors([])
                } name="current_password" rules={ rules.current_password } label="Current Password :" className="da-mb-16"
                  { ...getErrorProps(errors['current_password']) }
                >
                  <Input.Password placeholder="Enter your current password" autoComplete="current-password" />
                </Form.Item>
                <Form.Item onChange={
                  () => setErrors([])
                } name="new_password" rules={ rules.new_password } label="New Password :" className="da-mb-16"
                  { ...getErrorProps(errors['new_password']) }
                >
                  <Input.Password placeholder="Enter your new password" autoComplete="new-password" />
                </Form.Item>
                <Form.Item onChange={
                  () => setErrors([])
                } name="new_password_confirmation" dependencies={ ['new_password'] } rules={ rules.new_password_confirmation } label="Confirm New Password :" className="da-mb-16"
                  { ...getErrorProps(errors['new_password_confirmation']) }
                >
                  <Input.Password placeholder="Re-enter your new password" autoComplete="new-password" />
                </Form.Item>
              </Col>
              <Col span={ 24 } className="text-right ">
                <SaveButton style={ { width: '100%' } } form={ formName } key="create_button" htmlType="submit" state={ loader } />
              </Col>
            </Row>
          </div>
        </Form>
      </BodyComponent>
    </>
  )

}

const rules = {
  current_password: [
    { required: true, message: 'Please enter your current password!', },
  ],
  new_password: [
    { required: true, message: 'Please enter your new password!', },
    { min: 6, message: 'Minimum password length is 6', },
    { max: 32, message: 'Maximum password length is 32', },
  ],
  new_password_confirmation: [
    { required: true, message: 'Please confirm your new password!', },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue('new_password') === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('The two passwords do not match!'));
      },
    }),
  ],
};

export default ChangePassword
